import { TextureStyle } from "pixi.js";

import { Colors } from "../config/DesignConstants";
import Game from "../core/Game";
import FPSMeter from "../core/util/FPSMeter";
import BloomController from "./effects/BloomController";
import { GameCursor } from "./ui/GameCursor";
import VectorMainMenu from "./ui/MainMenu";
import { HighScoreManager } from "./util/HighScoreManager";

// Do this so we can access the game from the console
declare global {
  interface Window {
    DEBUG: { game?: Game };
  }
}

async function main() {
  // Make edges smooth
  TextureStyle.defaultOptions.scaleMode = "linear";

  const game = new Game();
  await game.init({ rendererOptions: { backgroundColor: Colors.BLACK } });
  // Make the game accessible from the console
  window.DEBUG = { game };

  // Add cleanup handler for when user navigates away
  const cleanup = () => {
    game.destroy();
  };
  window.addEventListener("beforeunload", cleanup);
  window.addEventListener("pagehide", cleanup);

  if (process.env.NODE_ENV === "development") {
    game.addEntity(new FPSMeter());
  }

  // Add bloom controller for vector CRT display simulation with tempo sync
  game.addEntity(new BloomController());

  // Initialize high score manager (persistent singleton)
  game.addEntity(new HighScoreManager());
  game.addEntity(new GameCursor());
  game.addEntity(new VectorMainMenu());
}

window.addEventListener("load", main);
